const getLabelForOption = (text: string): string => text.length > 50 ? `${text.substring(0, 47)}...` : text;

export default getLabelForOption;
